import React from 'react'
import { WHATSAPP_CONSULTATION_URL } from '../../../constants/contactUrls'

export const JpeEmptyPlan = (): React.JSX.Element => {
  return (
    <section className="px-6 py-10 rounded-12" style={{ background: '#FFFBF3' }}>
      <div className="mb-6 flex justify-center">
        <img
          alt="Our planners"
          className="w-full rounded-12 object-cover"
          src="/images/reservation_lp/consultation_jpe.webp"
          style={{ maxHeight: 360 }}
        />
      </div>

      <h2 className="text-xl font-bold text-green mb-3 md:text-xl">Can&apos;t Decide Where to Go?</h2>
      <p className="text-sm text-gray-700 leading-relaxed mb-6 md:text-base">
        Considering a JPE but unsure how to choose the right destination? We offer personalized support to help you find the
        perfect location for your family.
      </p>

      <h3 className="text-xl font-bold text-green mb-2 md:text-xl">Consult via WhatsApp</h3>
      <p className="text-sm text-gray-700 leading-relaxed md:text-base">
        Our planners are here to answer any questions you have via chat.
      </p>
      <p className="text-sm text-gray-700 mt-1 md:text-base">
        【Hours】 Weekdays 9:00 AM - 6:00 PM (Closed on weekends and holidays)
      </p>

      <div className="mt-8 text-center">
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-green text-white font-bold px-10 py-4 rounded-lg text-sm md:text-base md:px-16 w-80 max-w-md"
          href={WHATSAPP_CONSULTATION_URL}
        >
          Consult via WhatsApp
        </a>
      </div>
    </section>
  )
}
